export default "__VITE_ASSET__B8H92O_L__"